import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { NgxSpinnerService } from 'ngx-spinner';
import { ReservationType } from 'src/app/models/ReservationType';
import { ZoneModal } from 'src/app/models/Zone';
import { ReservationService } from 'src/app/services/reservation/reservation.service';
declare var $: any;
@Component({
  selector: 'app-add-reservation-type',
  templateUrl: './add-reservation-type.component.html',
  styleUrls: ['./add-reservation-type.component.scss']
})
export class AddReservationTypeComponent {
  @Input() modelId: any;
  @Input() modalName: string;
  @Input() title: string;
  @Input() modalType: string;
  @Input() routeName: string;
  @Input() clickedBrandId: string;
  @Input() selectedOutlet: number;
  @Input() selectedReservationType: ReservationType;
  @Input() id: any;
  @Input() reservationTypeChange: string;

  @Output() clearZones = new EventEmitter<any>();
  @Output() clearForms = new EventEmitter<any>();

  bsConfig: Partial<BsDatepickerConfig>;
  submitted: any = false
  brand: any = false
  isSuccess: any = false
  loading: any = false
  formMessage: any = ''
  fileTypes = ["image/png", "image/jpeg"];
  profilePic: any;
  profileURl: any = '';
  reservationType: ReservationType;
  allZones: Array<ZoneModal> = [];
  selectedStartDate: string = moment().format('YYYY-MM-DD');
  reservationTypes: Array<Object> = [
    { id: 1, name: 'Simple', value: 'SIMPLE' },
    { id: 2, name: 'Schedule', value: 'SCHEDULE' },
    { id: 3, name: 'Repeat', value: 'REPEAT' },
  ];
  manualConfirmTypes: Array<Object> = [
    { id: 1, name: 'Zone', value: 'Zone' },
    { id: 2, name: 'Yes', value: 'YES' },
    { id: 3, name: 'No', value: 'No' },
  ];
  availableDays: Array<Object> = [
    { day: 'Monday', isChecked: false },
    { day: 'Tuesday', isChecked: false },
    { day: 'Wednesday', isChecked: false },
    { day: 'Thursday', isChecked: false },
    { day: 'Friday', isChecked: false },
    { day: 'Saturday', isChecked: false },
    { day: 'Sunday', isChecked: false }
  ]
  allDurations: any = [
    { id: 0, start_time: 'start_time', end_time: "end_time" }
  ];

  constructor(private spinner: NgxSpinnerService,
    private reservations: ReservationService,) {
  }

  ngOnInit(): void {
    this.spinner.show()
    this.reservationType = this.reservationTypeForm.value
    $('#spicker_zones').selectpicker('val');
    $('#spicker_zones').selectpicker('refresh');
  }


  ngOnChanges() {
    console.log(this.selectedReservationType, this.modalType, this.id, "this.selectedReservationType 12s");

    this.getZones()

    if (this.reservationTypeChange == "changed") {
      this.selectZones()
      this.getValues()
    } else {
      this.clearFormData()
      $('#spicker_zones').selectpicker('val', '');
      $('#spicker_zones').selectpicker('refresh');
    }
    $('#spicker_zones').selectpicker('refresh');
  }

  reservationTypeForm: FormGroup = new FormGroup({
    name: new FormControl('', [Validators.required]),
    description: new FormControl('', [Validators.required]),
    thumbnail: new FormControl(null),
    manual_confirmation: new FormControl('', [Validators.required]),
    zones: new FormControl([], [Validators.required]),
    deposit_amount: new FormControl(''),
    deposit_type: new FormControl(''),
    is_refundable: new FormControl(''),
    max_party_size: new FormControl('', [Validators.required]),
    availability_type: new FormControl('', [Validators.required]),
    force_deposit: new FormControl(0, [Validators.required]),
    status: new FormControl(1, [Validators.required]),
    start_date: new FormControl('',),
    end_date: new FormControl('',),
    days: new FormControl('',),
    duration: new FormGroup({
      start_time: new FormControl('',),
      end_time: new FormControl('',),
    }),
  })

  get reservationTypeFormControls() { return this.reservationTypeForm.controls; }

  getValues() {
    if (this.selectedReservationType?.force_deposit != 0) {
      this.reservationTypeForm.patchValue(this.selectedReservationType);
    } else {
      this.reservationTypeForm.patchValue(this.selectedReservationType);
      this.reservationTypeForm.patchValue({
        deposit_amount: '',
        deposit_type: '',
        is_refundable: ''
      })
    }

    this.reservationType = this.reservationTypeForm.value
    let res = [];
    let nedw = this.availableDays;
    let tmpZones = [];
    let selectedZones = [];
    if (this.selectedReservationType) {

      (this.selectedReservationType?.zones).forEach((value, index) => {
        tmpZones.push(value['id']);
      });

      (this.allZones).forEach((value, index) => {
        if (tmpZones.includes(value['id'])) {
          selectedZones.push(index + ': ' + value['id']);
        }
      });

      this.reservationTypeForm.patchValue({
        zones: tmpZones
      });

    }

    setTimeout(function () {
      $('#spicker_zones').selectpicker('val', selectedZones);
      $('#spicker_zones').selectpicker('refresh');

    }, 100);

    $('#spicker_zones').selectpicker('refresh');

    res = nedw.filter(el => {
      return this.selectedReservationType.days.find(element => {
        return element == el['day'];
      });
    });

    res.forEach(element => {
      let index = this.availableDays.indexOf(element);

      if (index !== -1) {
        this.availableDays[index] = { day: element.day, isChecked: true }
      } else {
        this.availableDays = [
          { day: 'Monday', isChecked: false },
          { day: 'Tuesday', isChecked: false },
          { day: 'Wednesday', isChecked: false },
          { day: 'Thursday', isChecked: false },
          { day: 'Friday', isChecked: false },
          { day: 'Saturday', isChecked: false },
          { day: 'Sunday', isChecked: false }
        ]
      }

    })
    let times = this.selectedReservationType['available_times'];

    let table_info = this.reservationTypeForm.controls.duration as FormGroup;

    for (let i = 0; i < times.length; i++) {

      let controlName1 = 'start_time' + (this.allDurations[this.allDurations.length - 1].id + 1);
      let controlName2 = 'end_time' + (this.allDurations[this.allDurations.length - 1].id + 1);

      table_info.addControl(controlName1, new FormControl(times[i].start_time, [Validators.required]));
      table_info.addControl(controlName2, new FormControl(times[i].end_time, [Validators.required]));

      let object = {
        id: this.allDurations[this.allDurations.length - 1].id + 1,
        start_time: controlName1,
        end_time: controlName2,
      }

      this.allDurations.push(object);
    }
    this.allDurations.shift();

    table_info.removeControl("start_time");
    table_info.removeControl("end_time");

  }

  getZones() {
    this.reservations.getZones(this.selectedOutlet).subscribe({
      next: (res) => {
        this.allZones = res.data;
      },
      error: (error) => {
        console.log(error);
      }
    });

  }

  clearFormData() {
    this.allZones = []
    this.profileURl = '';
    this.reservationTypeForm.removeControl('name');
    this.reservationTypeForm.removeControl('description');
    this.reservationTypeForm.removeControl('thumbnail');
    this.reservationTypeForm.removeControl('manual_confirmation');
    this.reservationTypeForm.removeControl('zones');
    this.reservationTypeForm.removeControl('deposit_amount');
    this.reservationTypeForm.removeControl('deposit_type');
    this.reservationTypeForm.removeControl('is_refundable');
    this.reservationTypeForm.removeControl('max_party_size');
    this.reservationTypeForm.removeControl('availability_type');
    this.reservationTypeForm.removeControl('force_deposit');
    this.reservationTypeForm.removeControl('status');
    this.reservationTypeForm.removeControl('start_date');
    this.reservationTypeForm.removeControl('end_date');
    this.reservationTypeForm.removeControl('days');

    this.reservationTypeForm.addControl('name', new FormControl('', [Validators.required]));
    this.reservationTypeForm.addControl('description', new FormControl('', [Validators.required]));
    this.reservationTypeForm.addControl('thumbnail', new FormControl(null,));
    this.reservationTypeForm.addControl('manual_confirmation', new FormControl('', [Validators.required]));
    this.reservationTypeForm.addControl('zones', new FormControl([], [Validators.required]));
    this.reservationTypeForm.addControl('deposit_amount', new FormControl(''));
    this.reservationTypeForm.addControl('deposit_type', new FormControl(''));
    this.reservationTypeForm.addControl('is_refundable', new FormControl(''));
    this.reservationTypeForm.addControl('max_party_size', new FormControl('', [Validators.required]));
    this.reservationTypeForm.addControl('availability_type', new FormControl('', [Validators.required]));
    this.reservationTypeForm.addControl('force_deposit', new FormControl('', [Validators.required]));
    this.reservationTypeForm.addControl('status', new FormControl(1, [Validators.required]));
    this.reservationTypeForm.addControl('start_date', new FormControl('',));
    this.reservationTypeForm.addControl('end_date', new FormControl('',));
    this.reservationTypeForm.addControl('days', new FormControl('',));

    let table_info = this.reservationTypeForm.controls.duration as FormGroup;

    this.allDurations = []
    table_info.addControl('start_time', new FormControl(''));
    table_info.addControl('end_time', new FormControl(''));
    this.allDurations = [
      { id: 0, start_time: 'start_time', end_time: "end_time" }
    ]
    this.reservationTypeForm.patchValue({
      force_deposit: 0,
    })

    this.reservationType = this.reservationTypeForm.value;

    this.availableDays = [
      { day: 'Monday', isChecked: false },
      { day: 'Tuesday', isChecked: false },
      { day: 'Wednesday', isChecked: false },
      { day: 'Thursday', isChecked: false },
      { day: 'Friday', isChecked: false },
      { day: 'Saturday', isChecked: false },
      { day: 'Sunday', isChecked: false }
    ]
    $('#spicker_zones').selectpicker('refresh');
    $('#spicker_zones').selectpicker('val');

  }

  addImage(e: any) {
    let selected = e.target.files[0];
    if (selected && this.fileTypes.includes(selected.type)) {
      this.profilePic = selected

      var reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);

      reader.onload = (_event) => {
        this.profileURl = reader.result;
        this.reservationTypeForm.patchValue({
          thumbnail: selected.name,
        })
      }
    }
  }

  updateSwitch(type) {
    let value = this.reservationType[type] == 1 ? 0 : 1;

    if (type == 'force_deposit') {
      this.reservationTypeForm.patchValue({
        force_deposit: value
      })

      if (value == 1) {
        this.reservationTypeForm.controls['deposit_amount'].setValidators(Validators.required);
        this.reservationTypeForm.controls['deposit_type'].setValidators(Validators.required);
        this.reservationTypeForm.controls['is_refundable'].setValidators(Validators.required);
        this.reservationTypeForm.controls['deposit_amount'].updateValueAndValidity()
        this.reservationTypeForm.controls['deposit_type'].updateValueAndValidity()
        this.reservationTypeForm.controls['is_refundable'].updateValueAndValidity()
      } else {
        this.reservationTypeForm.removeControl('deposit_amount');
        this.reservationTypeForm.removeControl('deposit_type');
        this.reservationTypeForm.removeControl('is_refundable');
        this.reservationTypeForm.addControl('deposit_amount', new FormControl(''));
        this.reservationTypeForm.addControl('deposit_type', new FormControl(''));
        this.reservationTypeForm.addControl('is_refundable', new FormControl(''));
      }
    }
  }

  selectManualConfirm(event: any) {
    this.reservationTypeForm.patchValue({
      manual_confirmation: event
    })
  }

  selectZones() {
    $('#spicker_zones').selectpicker('refresh')
    setTimeout(() => {
      $('#spicker_zones').selectpicker('refresh')
    }, 500);
  }

  addTimeDurations() {
    let durations = this.reservationTypeForm.controls.duration as FormGroup;

    let controlName1 = 'start_time' + (this.allDurations[this.allDurations.length - 1].id + 1);
    let controlName2 = 'end_time' + (this.allDurations[this.allDurations.length - 1].id + 1);

    durations.addControl(controlName1, new FormControl('', [Validators.required]));
    durations.addControl(controlName2, new FormControl('', [Validators.required]));

    let object = {
      id: this.allDurations[this.allDurations.length - 1].id + 1,
      start_time: controlName1,
      end_time: controlName2,
    }

    this.allDurations.push(object);
  }

  deleteTimeDurations(value) {
    let durations = this.reservationTypeForm.controls.duration as FormGroup

    if (value.id === 0 && value.id > 0) {
      durations.removeControl(value.start_time);
      durations.removeControl(value.end_time);

      if (this.allDurations.findIndex(x => x.id === (value.id)) > -1) {
        this.allDurations.splice(this.allDurations.findIndex(x => x.id === (value.id)), 1);
      }
    } else {
      durations.removeControl(value.start_time);
      durations.removeControl(value.end_time);;

      if (this.allDurations.findIndex(x => x.id === (value.id)) > 0) {
        this.allDurations.splice(this.allDurations.findIndex(x => x.id === (value.id)), 1);
      }
    }
  }

  selectDay(value: any, event: any) {
    let index = this.availableDays.indexOf(value);

    if (index !== -1) {
      this.availableDays[index] = { day: value.day, isChecked: !value.isChecked }
    }
  }

  onAddClick() {
    this.submitted = true
    this.loading = true;
    let durations = [];
    let days = [];
    this.allDurations.forEach(element => {
      let obj = {
        start_time: this.reservationTypeForm.value.duration[element.start_time],
        end_time: this.reservationTypeForm.value.duration[element.end_time],
      }
      durations.push(obj)
    });

    days = this.availableDays.filter(function (el) {
      return el['isChecked'] == true;
    })

    console.log(this.reservationTypeForm, "this.reservationTypeForm.invalid");

    if (this.reservationTypeForm.invalid) {
      this.loading = false;
      this.isSuccess = false;
      this.formMessage = 'Please fill all required fields!';
    } else {
      const formData = new FormData();

      let profilePic = this.profilePic ? this.profilePic : ''

      formData.append('shop_id', this.selectedOutlet.toString());
      formData.append('name', this.reservationTypeForm.value.name);
      formData.append('description', this.reservationTypeForm.value.description);
      formData.append('thumbnail', profilePic);
      formData.append('manual_confirmation', this.reservationTypeForm.value.manual_confirmation);
      formData.append('force_deposit', this.reservationTypeForm.value.force_deposit);
      formData.append('deposit_amount', this.reservationTypeForm.value.deposit_amount);
      formData.append('deposit_type', this.reservationTypeForm.value.deposit_type);
      formData.append('is_refundable', this.reservationTypeForm.value.is_refundable);
      formData.append('max_party_size', this.reservationTypeForm.value.max_party_size);
      formData.append('availability_type', this.reservationTypeForm.value.availability_type);
      formData.append('start_date', this.reservationTypeForm.value.start_date);
      formData.append('end_date', this.reservationTypeForm.value.end_date);
      formData.append('status', this.reservationTypeForm.value.status);

      for (let i = 0; i < this.reservationTypeForm.value.zones.length; i++) {
        formData.append('zones[' + i + ']', this.reservationTypeForm.value.zones[i]);
      }

      for (let i = 0; i < durations.length; i++) {
        formData.append('duration[' + i + '][start_time]', durations[i].start_time);
        formData.append('duration[' + i + '][end_time]', durations[i].end_time);
      }

      for (let i = 0; i < days.length; i++) {
        formData.append('days[' + i + ']', days[i].day);
      }

      this.reservations.createReservationType(formData).subscribe({
        next: (res) => {
          // console.log(res)
          this.loading = false;
          this.isSuccess = true;
          this.formMessage = 'Reservation Type Successfully Added!';
          this.clearZones.emit()
          this.onCancelClick()
          this.submitted = false
        },
        error: (error) => {
          console.log(error)
          this.loading = false;
          this.isSuccess = false;
          this.formMessage = error;
        }
      })
    }

  }


  onEditClick() {
    this.submitted = true
    this.loading = true;
    let durations = [];
    let days = [];
    this.allDurations.forEach(element => {
      let obj = {
        start_time: this.reservationTypeForm.value.duration[element.start_time],
        end_time: this.reservationTypeForm.value.duration[element.end_time],
      }
      durations.push(obj)
    });

    days = this.availableDays.filter(function (el) {
      return el['isChecked'] == true;
    })
    console.log(this.reservationTypeForm, "this.reservationTypeForm");
    if (this.reservationTypeForm.invalid) {
      this.loading = false;
      this.isSuccess = false;
      this.formMessage = 'Please fill all required fields!';
    } else {
      const formData = new FormData();

      let profilePic = this.profilePic ? this.profilePic : ''

      formData.append('shop_id', this.selectedOutlet.toString());
      formData.append('name', this.reservationTypeForm.value.name);
      formData.append('description', this.reservationTypeForm.value.description);
      formData.append('thumbnail', profilePic);
      formData.append('manual_confirmation', this.reservationTypeForm.value.manual_confirmation);
      formData.append('force_deposit', this.reservationTypeForm.value.force_deposit);
      formData.append('deposit_amount', this.reservationTypeForm.value.deposit_amount);
      formData.append('deposit_type', this.reservationTypeForm.value.deposit_type);
      formData.append('is_refundable', this.reservationTypeForm.value.is_refundable);
      formData.append('max_party_size', this.reservationTypeForm.value.max_party_size);
      formData.append('availability_type', this.reservationTypeForm.value.availability_type);
      formData.append('start_date', this.reservationTypeForm.value.start_date);
      formData.append('end_date', this.reservationTypeForm.value.end_date);
      formData.append('status', this.reservationTypeForm.value.status);
      formData.append('_method', 'PUT');

      for (let i = 0; i < this.reservationTypeForm.value.zones.length; i++) {
        formData.append('zones[' + i + ']', this.reservationTypeForm.value.zones[i]);
      }

      for (let i = 0; i < durations.length; i++) {
        formData.append('duration[' + i + '][start_time]', durations[i].start_time);
        formData.append('duration[' + i + '][end_time]', durations[i].end_time);
      }

      for (let i = 0; i < days.length; i++) {
        formData.append('days[' + i + ']', days[i].day);
      }

      this.reservations.updateReservationType(this.selectedReservationType.id, formData).subscribe({
        next: (res) => {
          this.loading = false;
          this.isSuccess = true;
          this.formMessage = 'Reservation Type Successfully Updated!';
          this.clearZones.emit()
          this.onCancelClick()
          this.submitted = false
        },
        error: (error) => {
          console.log(error)
          this.loading = false;
          this.isSuccess = false;
          this.formMessage = error;
        }
      })
    }

  }



  onRTypeChange(type) {
    let table_info = this.reservationTypeForm.controls.duration as FormGroup;

    this.allDurations.forEach(element => {
      console.log(element, "allDurations");

      table_info.removeControl(element['start_time']);
      table_info.removeControl(element['end_time']);;

    });
    this.allDurations = []

    table_info.addControl('start_time', new FormControl(''));
    table_info.addControl('end_time', new FormControl(''));
    this.allDurations = [
      { id: 0, start_time: 'start_time', end_time: "end_time" }
    ]

    this.reservationTypeForm.removeControl('start_date');
    this.reservationTypeForm.removeControl('end_date');
    this.reservationTypeForm.addControl('start_date', new FormControl('',));
    this.reservationTypeForm.addControl('end_date', new FormControl('',));

    if (type == 'SIMPLE' || type == 'SCHEDULE' || type == 'REPEAT') {
      this.submitted = false
      let table_info = this.reservationTypeForm.controls.duration as FormGroup;

      table_info.controls['start_time'].setValidators(Validators.required);
      table_info.controls['end_time'].setValidators(Validators.required);
      table_info.controls['start_time'].updateValueAndValidity()
      table_info.controls['end_time'].updateValueAndValidity()

      if (type == 'SCHEDULE' || type == 'REPEAT') {
        this.reservationTypeForm.controls['start_date'].setValidators(Validators.required);
        this.reservationTypeForm.controls['end_date'].setValidators(Validators.required);
        this.reservationTypeForm.controls['start_date'].updateValueAndValidity();
        this.reservationTypeForm.controls['end_date'].updateValueAndValidity();
      }
    }

  }

  onCancelClick() {
    this.clearForms.emit()
    this.submitted = false
    let table_info = this.reservationTypeForm.controls.duration as FormGroup;

    this.allDurations.forEach(element => {

      table_info.removeControl(element['start_time']);
      table_info.removeControl(element['end_time']);;

    });
    this.availableDays = []
    table_info.addControl('start_time', new FormControl(''));
    table_info.addControl('end_time', new FormControl(''));


    this.reservationTypeForm.get('name').clearValidators();
    this.reservationTypeForm.get('description').clearValidators();
    this.reservationTypeForm.get('thumbnail').clearValidators();
    this.reservationTypeForm.get('manual_confirmation').clearValidators();
    this.reservationTypeForm.get('zones').clearValidators();
    this.reservationTypeForm.get('deposit_amount').clearValidators();
    this.reservationTypeForm.get('deposit_type').clearValidators();
    this.reservationTypeForm.get('is_refundable').clearValidators();
    this.reservationTypeForm.get('max_party_size').clearValidators();
    this.reservationTypeForm.get('availability_type').clearValidators();
    this.reservationTypeForm.get('force_deposit').clearValidators();
    this.reservationTypeForm.get('status').clearValidators();
    this.reservationTypeForm.get('start_date').clearValidators();
    this.reservationTypeForm.get('end_date').clearValidators();
    this.reservationTypeForm.get('days').clearValidators();

    $('#spicker_zones').selectpicker('val');
    $('#spicker_zones').selectpicker('refresh');
    this.clearFormData()
  }
}
